import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index';
// import bigData from '@/components1/bigData';
// import smartCommunity from '@/components1/smartCommunity';
// import companyIntroduce from "@/components1/companyIntroduce";
import Layout from '@/layout'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      component: Layout,
      hidden: true,
      name: '官网',
      children: [
        {
          path: '/',
          component: (resolve) => require(['@/components/index'], resolve),
          name: '首页',
          meta:{
            title:'首页'
          }
        },
      ],
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js